export const LabelSetting = {
  Demand: require("./labels/demand-labels.json"),
  Action: require("./labels/action-labels.json"),
  Person: require("./labels/person-labels.json"),
  Agenda: require("./labels/agenda-labels.json"),
  Task: require("./labels/task-labels.json"),
  Property: {
    ...require("./labels/property-labels.json"),
    ...require("./labels/property-administration-labels.json"),
    ...require("./labels/property-general-characteristics.json"),
    ...require("./labels/property-history-labels.json"),
    ...require("./labels/property-environment-labels.json"),
    ...require("./labels/property-relation-labels.json"),
    ...require('./labels/property-construction-labels.json'),
    ...require('./labels/property-warning-message.json'),
    ...require('./labels/property-costs-labels.json')
  },
  UploadControl: require("./labels/upload-control-labels.json"),
  Status: require("./labels/status-labels.json"),
  ConfirmDialog: require("./labels/confirmation-dialog-labels.json"),
  Report: require("./labels/report-labels.json"),
  Favourite: require("./labels/favourite-lablels.json"),
  DatePicker: require("./labels/datepicker-config.json"),
  Global: require("./labels/global-labels.json"),
  Project: {
    ...require("./labels/project-labels.json")
  },
  SocialSharing: {
    ...require('./labels/property-social-sharing-labels.json')
  },
  Portal: {
    ...require('./labels/portal.json')
  }
};
